import type { FC } from 'react';

/** Радиальная засветка от левого верхнего угла — общий декоративный слой карточек,
 *  которые залиты градиентом редкости. Лежит поверх фона и под содержимым.
 *
 *  Рисуется `<span>`, а не `<div>`, намеренно: у абсолютно позиционированного элемента
 *  `display` всё равно блокируется браузером, так что вид не меняется, зато такой слой
 *  валиден и внутри `<button>` — а из шести мест внутри карточек призов одно уже сидит
 *  в кнопке, и снаружи (`AuctionRibbonCard`) тоже. Значит остальные места смогут перейти
 *  на этот компонент без единого пропса.
 *
 *  Пропсов нет сознательно: все шесть вхождений внутри карточек призов совпадают дословно. */
export const RarityGlowOverlay: FC = () => (
  <span
    aria-hidden
    className="pointer-events-none absolute inset-0 opacity-25"
    style={{ background: 'radial-gradient(circle at 22% 12%, rgba(255,255,255,0.55), transparent 55%)' }}
  />
);
